import CreateKeyResultDialog from './CreateKeyResultDialogContainer';

export default CreateKeyResultDialog;
